//Effects
import { all, put, select, takeLatest } from 'redux-saga/effects';
import axios from 'axios';

import { createNotification } from '../../modules/notificationManager';
import {
  ADD_DEFAULT_SUB_TASKS,
  ADD_DEFAULT_SUB_TASKS_FAILURE,
  ADD_DEFAULT_SUB_TASKS_SUCCESS,
  ADD_EMTITHAL_MASTER_TASK,
  ADD_EMTITHAL_MASTER_TASK_FAILURE,
  ADD_EMTITHAL_MASTER_TASK_SUCCESS,
  ADD_MASTER_SUBTASK,
  ADD_MASTER_SUBTASK_FAILURE,
  ADD_MASTER_SUBTASK_SUCCESS,
  ADD_MASTER_TASK,
  ADD_MASTER_TASK_FAILURE,
  ADD_MASTER_TASK_SUCCESS,
  ADD_SUB_TASK,
  ADD_SUB_TASK_FAILURE,
  ADD_SUB_TASK_SUCCESS,
  ADD_TASK_LOCATION,
  ADD_TASK_LOCATION_FAILURE,
  ADD_TASK_LOCATION_SUCCESS,
  CREATE_TASK,
  CREATE_TASK_FAILURE,
  CREATE_TASK_SUCCESS,
  DELETE_SUB_TASK,
  DELETE_SUB_TASK_FAILURE,
  DELETE_SUB_TASK_SUCCESS,
  DELETE_TASK,
  DELETE_TASK_FAILURE,
  DELETE_TASK_SUCCESS,
  DUPLICATE_TASK,
  DUPLICATE_TASK_FAILURE,
  DUPLICATE_TASK_SUCCESS,
  EDIT_EMTITHAL_MASTER_TASK,
  EDIT_EMTITHAL_MASTER_TASK_FAILURE,
  EDIT_EMTITHAL_MASTER_TASK_SUCCESS,
  EDIT_MASTER_SUBTASK,
  EDIT_MASTER_SUBTASK_FAILURE,
  EDIT_MASTER_SUBTASK_SUCCESS,
  EDIT_MASTER_TASK,
  EDIT_MASTER_TASK_FAILURE,
  EDIT_MASTER_TASK_SUCCESS,
  EDIT_SUB_TASK,
  EDIT_SUB_TASK_FAILURE,
  EDIT_SUB_TASK_SUCCESS,
  EDIT_TASK,
  EDIT_TASK_FAILURE,
  EDIT_TASK_SUCCESS,
  GET_DEFAULT_SUB_TASKS,
  GET_DEFAULT_SUB_TASKS_FAILURE,
  GET_DEFAULT_SUB_TASKS_SUCCESS,
  GET_ITEM_SUB_TASKS,
  GET_ITEM_SUB_TASKS_FAILURE,
  GET_ITEM_SUB_TASKS_SUCCESS,
  GET_EMTITHAL_MASTER_TASKS,
  GET_EMTITHAL_MASTER_TASKS_FAILURE,
  GET_EMTITHAL_MASTER_TASKS_SUCCESS,
  GET_MAIN_TASK_LIST,
  GET_MAIN_TASK_LIST_FAILURE,
  GET_MAIN_TASK_LIST_SUCCESS,
  GET_EMTITHAL_OFFICE_TASKS,
  GET_EMTITHAL_OFFICE_TASKS_FAILURE,
  GET_EMTITHAL_OFFICE_TASKS_SUCCESS,
  EXPORT_EMTITHAL_OFFICE_TASKS_REPORT,
  EXPORT_EMTITHAL_OFFICE_TASKS_REPORT_FAILURE,
  EXPORT_EMTITHAL_OFFICE_TASKS_REPORT_SUCCESS,
  GET_MASTER_SUBTASKS,
  GET_MASTER_SUBTASKS_FAILURE,
  GET_MASTER_SUBTASKS_SUCCESS,
  GET_MASTER_TASKS,
  GET_MASTER_TASKS_FAILURE,
  GET_MASTER_TASKS_SUCCESS,
  GET_SUB_TASKS,
  GET_SUB_TASKS_FAILURE,
  GET_SUB_TASKS_SUCCESS,
  GET_SUB_TASK_DETAILS,
  GET_SUB_TASK_DETAILS_FAILURE,
  GET_SUB_TASK_DETAILS_SUCCESS,
  GET_SUB_TASK_EVIDENCE,
  GET_SUB_TASK_EVIDENCE_FAILURE,
  GET_SUB_TASK_EVIDENCE_SUCCESS,
  GET_TASKS_LIST,
  GET_TASKS_LIST_FAILURE,
  GET_TASKS_LIST_SUCCESS,
  GET_TASK_DETAILS,
  GET_TASK_DETAILS_FAILURE,
  GET_TASK_DETAILS_SUCCESS,
  GET_TASK_LOCATIONS,
  GET_TASK_LOCATIONS_FAILURE,
  GET_TASK_LOCATIONS_SUCCESS,
  GET_TASK_TYPE,
  GET_TASK_TYPE_FAILURE,
  GET_TASK_TYPE_SUCCESS,
  UPDATE_SUB_TASK_APPROVAL,
  UPDATE_SUB_TASK_APPROVAL_FAILURE,
  UPDATE_SUB_TASK_APPROVAL_SUCCESS,
  UPDATE_TASK_STATUS,
  UPDATE_TASK_STATUS_FAILURE,
  UPDATE_TASK_STATUS_SUCCESS,
  EXPORT_OFFICE_SUBTASK_REPORT,
  EXPORT_OFFICE_SUBTASK_REPORT_FAILURE,
  EXPORT_OFFICE_SUBTASK_REPORT_SUCCESS,
  EXPORT_ALL_SUBTASK_PUBLIC_ZONE_REPORT,
  EXPORT_ALL_SUBTASK_PUBLIC_ZONE_REPORT_FAILURE,
  EXPORT_ALL_SUBTASK_PUBLIC_ZONE_REPORT_SUCCESS,
} from '../../modules/constants';
//Service
import { defaultApi } from '../../utils/axiosApi';
import details from '../IntegrationsNew/Details';

export function* handleGetTasksList({ payload }) {
  const {
    startDate,
    endDate,
    page,
    task_name,
    office_id,
    assignee_id,
    status,
    approval_status,
    location_id,
    public_zone_id,
    not_updated_since_days,
    not_updated_at_all,
  } = payload;
  try {
    const url = `/tasks/?required_start_date=${startDate}&required_end_date=${endDate}${page ? `&page=${page}` : ''
      }${task_name ? `&name=${task_name}` : ''}${office_id ? `&office_id=${office_id}` : ''
      }${public_zone_id ? `&public_zone_id=${public_zone_id}` : ''}${location_id ? `&location_id=${location_id}` : ''
      }${assignee_id ? `&assignees=${assignee_id}` : ''}${status ? `&status=${status}` : ''
      }${approval_status ? `&approval_status=${approval_status}` : ''}${not_updated_since_days ? `&not_updated_since_days=${not_updated_since_days}` : ''
      }${not_updated_at_all !== undefined ? `&not_updated_at_all=${not_updated_at_all}` : ''
      }`;
    const response = yield defaultApi(url, 'GET', payload);
    yield put({
      type: GET_TASKS_LIST_SUCCESS,
      payload: { data: response },
    });
  } catch (err) {
    yield put({
      type: GET_TASKS_LIST_FAILURE,
      payload: err,
    });
  }
}

export function* handleCreateTaskList({ payload }) {
  try {
    const { ...details } = payload;
    const url = `/tasks/`;
    const method = 'POST';
    const response = yield defaultApi(url, method, details);
    yield put({
      type: CREATE_TASK_SUCCESS,
      payload: { data: response, notify: 'POST' },
    });
  } catch (err) {
    yield put({
      type: CREATE_TASK_FAILURE,
      payload: err,
    });
  }
}

export function* handleGetTaskDetails({ payload }) {
  try {
    const { task_id } = payload;
    const url = `/tasks/${task_id}/`;
    const method = 'GET';
    const response = yield defaultApi(url, method);
    yield put({
      type: GET_TASK_DETAILS_SUCCESS,
      payload: { data: response },
    });
  } catch (err) {
    yield put({
      type: GET_TASK_DETAILS_FAILURE,
      payload: err,
    });
  }
}

export function* handleEditTask({ payload }) {
  try {
    const { task_id, ...details } = payload;
    const url = `/tasks/${task_id}/`;
    const response = yield defaultApi(url, 'PUT', details);
    yield put({
      type: EDIT_TASK_SUCCESS,
      payload: { data: response },
    });
  } catch (err) {
    yield put({
      type: EDIT_TASK_FAILURE,
      payload: err,
    });
  }
}

export function* handleAddSubTask({ payload }) {
  try {
    const { task_id, ...details } = payload;
    const url = `/tasks/${task_id}/sub/`;
    const response = yield defaultApi(url, 'POST', details.data);
    yield put({
      type: ADD_SUB_TASK_SUCCESS,
      payload: { task_id, data: response },
    });
  } catch (err) {
    yield put({
      type: ADD_SUB_TASK_FAILURE,
      payload: err,
    });
  }
}

export function* handleGetDefaultSubTasks({ payload }) {
  try {
    const queryParams = new URLSearchParams(payload).toString();

    const public_zone_id = payload?.public_zone_id;
    const url = `/tasks/default-sub-task/${queryParams ? `?${queryParams}` : ''
      }`;
    const response = yield defaultApi(url, 'GET');
    yield put({
      type: GET_DEFAULT_SUB_TASKS_SUCCESS,
      payload: { ...payload, data: response },
    });
  } catch (err) {
    yield put({
      type: GET_DEFAULT_SUB_TASKS_FAILURE,
      payload: err,
    });
  }
}

export function* handleGetSubTasks({ payload }) {
  const {
    startDate,
    endDate,
    page,
    task_name,
    office_id,
    assignee_id,
    status,
    approval_status,
    location_id,
    public_zone_id,
    default_sub_task_code,
    not_updated_since_days,
    not_updated_at_all,
    master_task_id,
  } = payload;
  try {
    const url = `/tasks/sub_tasks/?required_start_date=${startDate}&required_end_date=${endDate}${page ? `&page=${page}` : ''
      }${task_name ? `&name=${task_name}` : ''}${office_id ? `&office_id=${office_id}` : ''
      }${public_zone_id ? `&public_zone_id=${public_zone_id}` : ''}${default_sub_task_code
        ? `&default_sub_task_code=${default_sub_task_code}`
        : ''
      }${location_id ? `&location_id=${location_id}` : ''}${assignee_id ? `&assignees=${assignee_id}` : ''
      }${status ? `&status=${status}` : ''}${approval_status ? `&approval_status=${approval_status}` : ''
      }${master_task_id ? `&master_task_id=${master_task_id}` : ''
      }${not_updated_since_days ? `&not_updated_since_days=${not_updated_since_days}` : ''
      }${not_updated_at_all ? `&not_updated_at_all=${not_updated_at_all}` : ''
      }`;
    const response = yield defaultApi(url, 'GET');
    yield put({
      type: GET_SUB_TASKS_SUCCESS,
      payload: { data: response },
    });
  } catch (err) {
    yield put({
      type: GET_SUB_TASKS_FAILURE,
      payload: err,
    });
  }
}

export function* handleGetSubTaskDetails({ payload }) {
  const { id } = payload;
  try {
    const url = `/tasks/sub_tasks/${id}/`;
    const response = yield defaultApi(url, 'GET');
    yield put({
      type: GET_SUB_TASK_DETAILS_SUCCESS,
      payload: { data: response },
    });
  } catch (err) {
    yield put({
      type: GET_SUB_TASK_DETAILS_FAILURE,
      payload: err,
    });
  }
}

export function* handleAddDefaultSubTasks({ payload }) {
  try {
    const { ...details } = payload;
    const url = `/tasks/default-sub-task/`;
    const response = yield defaultApi(url, 'POST', details);
    yield put({
      type: ADD_DEFAULT_SUB_TASKS_SUCCESS,
      payload: { data: response },
    });
  } catch (err) {
    yield put({
      type: ADD_DEFAULT_SUB_TASKS_FAILURE,
      payload: err,
    });
  }
}

export function* handleGetSubTaskEvidence({ payload }) {
  try {
    const { task_id, sub_task_id } = payload;
    const url = `/tasks/${sub_task_id}/sub-task-evidences/`;
    const response = yield defaultApi(url, 'GET');
    yield put({
      type: GET_SUB_TASK_EVIDENCE_SUCCESS,
      payload: { task_id, sub_task_id, data: response },
    });
  } catch (err) {
    yield put({
      type: GET_SUB_TASK_EVIDENCE_FAILURE,
      payload: err,
    });
  }
}

export function* handleEditSubTask({ payload }) {
  try {
    const { task_id, sub_task_id, ...details } = payload;
    const url = `/tasks/${task_id}/sub/${sub_task_id}/`;
    const response = yield defaultApi(url, 'PATCH', details.data);
    yield put({
      type: EDIT_SUB_TASK_SUCCESS,
      payload: { task_id, sub_task_id, data: response },
    });
  } catch (err) {
    yield put({
      type: EDIT_SUB_TASK_FAILURE,
      payload: err,
    });
  }
}

export function* handleDeleteSubTask({ payload }) {
  try {
    const { task_id, sub_task_id } = payload;
    const url = `/tasks/${task_id}/sub/${sub_task_id}/`;
    const response = yield defaultApi(url, 'DELETE');
    yield put({
      type: DELETE_SUB_TASK_SUCCESS,
      payload: { task_id, sub_task_id, data: response },
    });
  } catch (err) {
    yield put({
      type: DELETE_SUB_TASK_FAILURE,
      payload: err,
    });
  }
}

export function* handleDuplicateTask({ payload }) {
  try {
    const { organization_id, ...details } = payload;
    const url = `/tasks/duplicate-task`;
    const method = 'POST';
    const response = yield defaultApi(url, method, details);

    yield put({
      type: DUPLICATE_TASK_SUCCESS,
      payload: { data: response, notify: 'POST' },
    });
  } catch (err) {
    yield put({
      type: DUPLICATE_TASK_FAILURE,
      payload: err,
    });
  }
}

export function* handleDeleteTask({ payload }) {
  try {
    const { task_id } = payload;
    const url = `/tasks/${task_id}/`;
    const method = 'DELETE';
    const response = yield defaultApi(url, method);
    yield put({
      type: DELETE_TASK_SUCCESS,
      payload: { data: response, task_id, notify: 'DELETE' },
    });
  } catch (err) {
    yield put({
      type: DELETE_TASK_FAILURE,
      payload: err,
    });
  }
}

export function* handleGetTaskLocations({ payload }) {
  const office_id = payload?.office_id;
  const public_zone_id = payload?.public_zone_id;
  try {
    const url = `/task_locations/${office_id ? `?office_id=${office_id}` : ''}${public_zone_id
      ? `${office_id
        ? `&public_zone_id=${public_zone_id}`
        : `?public_zone_id=${public_zone_id}`
      }`
      : ''
      }`;
    const response = yield defaultApi(url, 'GET');
    yield put({
      type: GET_TASK_LOCATIONS_SUCCESS,
      payload: { data: response },
    });
  } catch (err) {
    yield put({
      type: GET_TASK_LOCATIONS_FAILURE,
      payload: err,
    });
  }
}

export function* handleAddTaskLocation({ payload }) {
  try {
    const { ...details } = payload;
    const url = `/task_locations/`;
    const method = 'POST';
    const response = yield defaultApi(url, method, details);

    yield put({
      type: ADD_TASK_LOCATION_SUCCESS,
      payload: { data: response, notify: 'POST' },
    });
  } catch (err) {
    yield put({
      type: ADD_TASK_LOCATION_FAILURE,
      payload: err,
    });
  }
}
export function* handleTaskApproval({ payload }) {
  const { task_id, data } = payload;
  try {
    const url = `tasks/${task_id}/approval/${task_id}/`;
    const method = 'PUT';
    const response = yield defaultApi(url, method, data);
    yield put({
      type: UPDATE_TASK_STATUS_SUCCESS,
      payload: { data: response, task_id },
    });
  } catch (err) {
    yield put({
      type: UPDATE_TASK_STATUS_FAILURE,
      payload: err,
    });
  }
}

export function* handleGetTaskType({ }) {
  try {
    const url = `/tasks/task-type/`;
    const response = yield defaultApi(url, 'GET', null);
    yield put({
      type: GET_TASK_TYPE_SUCCESS,
      payload: { data: response },
    });
  } catch (err) {
    yield put({
      type: GET_TASK_TYPE_FAILURE,
      payload: err,
    });
  }
}

export function* handleGetMasterTasks({ payload }) {
  try {
    const queryParams = new URLSearchParams(payload).toString();
    const url = `/albait/inspection-master-tasks/${queryParams ? `?${queryParams}` : ''
      }`;
    const response = yield defaultApi(url, 'GET');
    yield put({
      type: GET_MASTER_TASKS_SUCCESS,
      payload: { data: response },
    });
  } catch (err) {
    yield put({
      type: GET_MASTER_TASKS_FAILURE,
      payload: err,
    });
  }
}

export function* handleEditMasterTask({ payload }) {
  try {
    const { callback, task_id, ...details } = payload;
    const url = `/albait/inspection-master-tasks/${task_id}/`;
    const response = yield defaultApi(url, 'PATCH', details);
    yield put({
      type: EDIT_MASTER_TASK_SUCCESS,
      payload: { data: response },
    });
    if (callback) callback();
  } catch (err) {
    yield put({
      type: EDIT_MASTER_TASK_FAILURE,
      payload: err,
    });
  }
}

export function* handleAddMasterTask({ payload }) {
  try {
    const { callback, ...details } = payload;
    const url = `/albait/inspection-master-tasks/`;
    const response = yield defaultApi(url, 'POST', details);
    yield put({
      type: ADD_MASTER_TASK_SUCCESS,
      payload: { data: response },
    });
    if (callback) {
      callback();
    }
  } catch (err) {
    yield put({
      type: ADD_MASTER_TASK_FAILURE,
      payload: err,
    });
  }
}

export function* handleGetMasterSubTasks({ payload }) {
  try {
    const queryParams = new URLSearchParams(payload).toString();
    const url = `/tasks/default-sub-task/${queryParams ? `?${queryParams}` : ''
      }`;
    const response = yield defaultApi(url, 'GET');
    yield put({
      type: GET_MASTER_SUBTASKS_SUCCESS,
      payload: { data: response },
    });
  } catch (err) {
    yield put({
      type: GET_MASTER_SUBTASKS_FAILURE,
      payload: err,
    });
  }
}

export function* handleEditMasterSubTask({ payload }) {
  try {
    const { callback, task_id, ...details } = payload;
    const url = `/tasks/default-sub-task/${task_id}/`;
    const response = yield defaultApi(url, 'PATCH', details);
    yield put({
      type: EDIT_MASTER_SUBTASK_SUCCESS,
      payload: { data: response },
    });
    if (callback) callback();
  } catch (err) {
    yield put({
      type: EDIT_MASTER_SUBTASK_FAILURE,
      payload: err,
    });
  }
}

export function* handleAddMasterSubTask({ payload }) {
  try {
    const { callback, ...details } = payload;
    const url = `/tasks/default-sub-task/`;
    const response = yield defaultApi(url, 'POST', details);
    yield put({
      type: ADD_MASTER_SUBTASK_SUCCESS,
      payload: { data: response },
    });
    if (callback) {
      callback();
    }
  } catch (err) {
    yield put({
      type: ADD_MASTER_SUBTASK_FAILURE,
      payload: err,
    });
  }
}

// Emtithal Master Tasks - /api/albait/emtithal-master-tasks/
export function* handleGetEmtithalMasterTasks({ payload }) {
  try {
    const params = {};
    if (payload?.name) params.name = payload.name;
    if (payload?.code) params.code = payload.code;
    if (payload?.public_zone_id) params.public_zone = payload.public_zone_id;
    if (payload?.office_id) params.related_offices = payload.office_id;
    if (payload?.status) params.status = payload.status;
    if (payload?.is_show !== undefined) params.is_show = payload.is_show;
    const queryString = new URLSearchParams(params).toString();
    const url = `albait/emtithal-master-tasks/${queryString ? `?${queryString}` : ''}`;
    const response = yield defaultApi(url, 'GET');
    yield put({
      type: GET_EMTITHAL_MASTER_TASKS_SUCCESS,
      payload: { data: response },
    });
  } catch (err) {
    yield put({
      type: GET_EMTITHAL_MASTER_TASKS_FAILURE,
      payload: err,
    });
  }
}

// Main Task List - api/tasks/main-task-short/
export function* handleGetMainTaskList({ payload }) {
  try {
    const params = {};
    if (payload?.public_zone_id) params.public_zone_id = payload.public_zone_id;
    const queryString = new URLSearchParams(params).toString();
    const base = 'tasks/main-task-short/';
    const url = queryString ? `${base}?${queryString}` : base;
    const response = yield defaultApi(url, 'GET');
    yield put({
      type: GET_MAIN_TASK_LIST_SUCCESS,
      payload: { data: response },
    });
  } catch (err) {
    yield put({
      type: GET_MAIN_TASK_LIST_FAILURE,
      payload: err,
    });
  }
}

// Emtithal Office Tasks - api/albait/emtithal-office-tasks/
export function* handleGetEmtithalOfficeTasks({ payload }) {
  try {
    const params = {};
    if (payload?.page) params.page = payload.page;
    if (payload?.page_size) params.page_size = payload.page_size || 30;
    if (payload?.public_zone_id) params.public_zone_id = payload.public_zone_id;
    if (payload?.office_id) params.office_id = payload.office_id;
    if (payload?.location_id) params.location_id = payload.location_id;
    if (payload?.name) params.name = payload.name;
    if (payload?.code) params.code = payload.code;
    const queryString = new URLSearchParams(params).toString();
    const base = 'albait/emtithal-office-tasks/';
    const url = queryString ? `${base}?${queryString}` : base;
    const response = yield defaultApi(url, 'GET');
    yield put({
      type: GET_EMTITHAL_OFFICE_TASKS_SUCCESS,
      payload: { data: response },
    });
  } catch (err) {
    yield put({
      type: GET_EMTITHAL_OFFICE_TASKS_FAILURE,
      payload: err,
    });
  }
}

// Export Emtithal Office Tasks Report - api/albait/export/emtithal-office-task-report/
export function* handleExportEmtithalOfficeTasksReport({ payload }) {
  try {
    const params = {};
    if (payload?.public_zone_id) params.public_zone_id = payload.public_zone_id;
    if (payload?.office_id) params.office_id = payload.office_id;
    if (payload?.location_id) params.location_id = payload.location_id;
    if (payload?.name) params.name = payload.name;
    const queryString = new URLSearchParams(params).toString();
    const base = 'albait/export/emtithal-office-task-report/';
    const url = queryString ? `${base}?${queryString}` : base;
    
    const baseURL = `${process.env.REACT_APP_API_URL}/api/`;
    const token = localStorage.getItem('access_token');
    const headers = { 'Content-Type': 'blob', Authorization: `Bearer ${token}` };
    const config = {
      method: 'GET',
      url: `${baseURL}${url}`,
      responseType: 'arraybuffer',
      headers,
    };
    
    const response = yield axios(config);
    
    yield put({
      type: EXPORT_EMTITHAL_OFFICE_TASKS_REPORT_SUCCESS,
      payload: { data: response.data },
    });
  } catch (err) {
    yield put({
      type: EXPORT_EMTITHAL_OFFICE_TASKS_REPORT_FAILURE,
      payload: err,
    });
  }
}

export function* handleAddEmtithalMasterTask({ payload }) {
  try {
    const { callback, ...rest } = payload;
    const body = {
      name: rest.name,
      public_zone: rest.public_zone,
      status: rest.status || 'active',
      is_show: rest.is_show !== false,
      related_offices_ids: rest.related_offices_ids || [],
      sub_tasks_ids: rest.sub_tasks_ids || [],
    };
    const url = 'albait/emtithal-master-tasks/';
    const response = yield defaultApi(url, 'POST', body);
    yield put({
      type: ADD_EMTITHAL_MASTER_TASK_SUCCESS,
      payload: { data: response },
    });
    if (callback) callback();
  } catch (err) {
    yield put({
      type: ADD_EMTITHAL_MASTER_TASK_FAILURE,
      payload: err,
    });
  }
}

export function* handleEditEmtithalMasterTask({ payload }) {
  try {
    const { callback, task_id, ...rest } = payload;
    const body = {};
    if (rest.name !== undefined) body.name = rest.name;
    if (rest.public_zone !== undefined) body.public_zone = rest.public_zone;
    if (rest.status !== undefined) body.status = rest.status;
    if (rest.is_show !== undefined) body.is_show = rest.is_show;
    if (rest.related_offices_ids !== undefined)
      body.related_offices_ids = rest.related_offices_ids;
    if (rest.sub_tasks_ids !== undefined) body.sub_tasks_ids = rest.sub_tasks_ids;
    const url = `albait/emtithal-master-tasks/${task_id}/`;
    const response = yield defaultApi(url, 'PATCH', body);
    yield put({
      type: EDIT_EMTITHAL_MASTER_TASK_SUCCESS,
      payload: { data: response },
    });
    if (callback) callback();
  } catch (err) {
    yield put({
      type: EDIT_EMTITHAL_MASTER_TASK_FAILURE,
      payload: err,
    });
  }
}

export function* handleGetItemSubTasks({ payload }) {
  const {
    startDate,
    endDate,
    page,
    task_name,
    office_id,
    assignee_id,
    status,
    approval_status,
    location_id,
    public_zone_id,
    not_updated_since_days,
    not_updated_at_all,
  } = payload;
  try {
    const url = `/tasks/item-sub-tasks/?required_start_date=${startDate}&required_end_date=${endDate}${page ? `&page=${page}` : ''
      }${task_name ? `&name=${task_name}` : ''}${office_id ? `&office_id=${office_id}` : ''
      }${public_zone_id ? `&public_zone_id=${public_zone_id}` : ''}${location_id ? `&location_id=${location_id}` : ''
      }${assignee_id ? `&assignees=${assignee_id}` : ''}${status ? `&status=${status}` : ''
      }${approval_status ? `&approval_status=${approval_status}` : ''}${not_updated_since_days ? `&not_updated_since_days=${not_updated_since_days}` : ''
      }${not_updated_at_all !== undefined ? `&not_updated_at_all=${not_updated_at_all}` : ''
      }`;
    const response = yield defaultApi(url, 'GET', payload);
    yield put({
      type: GET_ITEM_SUB_TASKS_SUCCESS,
      payload: { data: response },
    });
  } catch (err) {
    yield put({
      type: GET_ITEM_SUB_TASKS_FAILURE,
      payload: err,
    });
  }
}

export function* handleSubTaskApproval({ payload }) {
  const { sub_task_id, data } = payload;
  try {
    const url = `tasks/${sub_task_id}/sub-task-approval/${sub_task_id}/`;
    const method = 'PATCH';
    const response = yield defaultApi(url, method, data);
    yield put({
      type: UPDATE_SUB_TASK_APPROVAL_SUCCESS,
      payload: { data: response, sub_task_id },
    });
  } catch (err) {
    yield put({
      type: UPDATE_SUB_TASK_APPROVAL_FAILURE,
      payload: err,
    });
  }
}

// Export Office Subtask Report - api/albait/export/office-subtask-report/
export function* handleExportOfficeSubtaskReport({ payload }) {
  try {
    const params = {};
    if (payload?.public_zone_id) params.public_zone_id = payload.public_zone_id;
    if (payload?.office_id) params.office_id = payload.office_id;
    if (payload?.readiness_percentage) params.readiness_percentage = payload.readiness_percentage;
    const queryString = new URLSearchParams(params).toString();
    const base = 'albait/export/office-subtask-report/';
    const url = queryString ? `${base}?${queryString}` : base;
    
    const baseURL = `${process.env.REACT_APP_API_URL}/api/`;
    const token = localStorage.getItem('access_token');
    const headers = { 'Content-Type': 'blob', Authorization: `Bearer ${token}` };
    const config = {
      method: 'GET',
      url: `${baseURL}${url}`,
      responseType: 'arraybuffer',
      headers,
    };
    
    const response = yield axios(config);
    
    yield put({
      type: EXPORT_OFFICE_SUBTASK_REPORT_SUCCESS,
      payload: { data: response.data },
    });
  } catch (err) {
    yield put({
      type: EXPORT_OFFICE_SUBTASK_REPORT_FAILURE,
      payload: err,
    });
  }
}

export function* handleExportAllSubtaskPublicZoneReport({ payload }) {
  try {
    const params = {};
    if (payload?.public_zone_id) params.public_zone_id = payload.public_zone_id;
    if (payload?.office_id) params.office_id = payload.office_id;
    const queryString = new URLSearchParams(params).toString();
    const base = 'albait/export/all-subtask-public-zone-report/';
    const url = queryString ? `${base}?${queryString}` : base;
    
    const baseURL = `${process.env.REACT_APP_API_URL}/api/`;
    const token = localStorage.getItem('access_token');
    const headers = { 'Content-Type': 'blob', Authorization: `Bearer ${token}` };
    const config = {
      method: 'GET',
      url: `${baseURL}${url}`,
      responseType: 'arraybuffer',
      headers,
    };
    
    const response = yield axios(config);
    
    yield put({
      type: EXPORT_ALL_SUBTASK_PUBLIC_ZONE_REPORT_SUCCESS,
      payload: { data: response.data },
    });
  } catch (err) {
    yield put({
      type: EXPORT_ALL_SUBTASK_PUBLIC_ZONE_REPORT_FAILURE,
      payload: err,
    });
  }
}

export default function* root() {
  yield all([
    // Get tasks list
    takeLatest(GET_TASKS_LIST, handleGetTasksList),
    // Create task
    takeLatest(CREATE_TASK, handleCreateTaskList),
    //Get task details
    takeLatest(GET_TASK_DETAILS, handleGetTaskDetails),
    //Update task
    takeLatest(EDIT_TASK, handleEditTask),
    //Get SUB_TASKS
    takeLatest(GET_SUB_TASKS, handleGetSubTasks),
    takeLatest(GET_SUB_TASK_DETAILS, handleGetSubTaskDetails),
    //Get DEFAULT_SUB_TASKS
    takeLatest(GET_DEFAULT_SUB_TASKS, handleGetDefaultSubTasks),
    //ADD DEFAULT_SUB_TASKS
    takeLatest(ADD_DEFAULT_SUB_TASKS, handleAddDefaultSubTasks),
    //Get Sub Task Evidence
    takeLatest(GET_SUB_TASK_EVIDENCE, handleGetSubTaskEvidence),
    //Add sub task
    takeLatest(ADD_SUB_TASK, handleAddSubTask),
    //Update sub task
    takeLatest(EDIT_SUB_TASK, handleEditSubTask),
    //Delete sub task
    takeLatest(DELETE_SUB_TASK, handleDeleteSubTask),
    //Duplicate task
    takeLatest(DUPLICATE_TASK, handleDuplicateTask),
    //Delete task
    takeLatest(DELETE_TASK, handleDeleteTask),
    // Get task location
    takeLatest(GET_TASK_LOCATIONS, handleGetTaskLocations),
    // Add task location
    takeLatest(ADD_TASK_LOCATION, handleAddTaskLocation),

    takeLatest(UPDATE_TASK_STATUS, handleTaskApproval),
    // Get task type
    takeLatest(GET_TASK_TYPE, handleGetTaskType),
    // Get master tasks
    takeLatest(GET_MASTER_TASKS, handleGetMasterTasks),
    // Add master task
    takeLatest(ADD_MASTER_TASK, handleAddMasterTask),
    // Edit master task
    takeLatest(EDIT_MASTER_TASK, handleEditMasterTask),
    // Get master subtasks
    takeLatest(GET_MASTER_SUBTASKS, handleGetMasterSubTasks),
    // Add master subtask
    takeLatest(ADD_MASTER_SUBTASK, handleAddMasterSubTask),
    // Edit master subtask
    takeLatest(EDIT_MASTER_SUBTASK, handleEditMasterSubTask),
    // Emtithal master tasks (same API as Master Sub Tasks for now)
    takeLatest(GET_EMTITHAL_MASTER_TASKS, handleGetEmtithalMasterTasks),
    takeLatest(ADD_EMTITHAL_MASTER_TASK, handleAddEmtithalMasterTask),
    takeLatest(EDIT_EMTITHAL_MASTER_TASK, handleEditEmtithalMasterTask),
    // Main task list
    takeLatest(GET_MAIN_TASK_LIST, handleGetMainTaskList),
    // Emtithal office tasks (list page)
    takeLatest(GET_EMTITHAL_OFFICE_TASKS, handleGetEmtithalOfficeTasks),
    takeLatest(EXPORT_EMTITHAL_OFFICE_TASKS_REPORT, handleExportEmtithalOfficeTasksReport),
    // Get item sub tasks list
    takeLatest(GET_ITEM_SUB_TASKS, handleGetItemSubTasks),
    // Update sub task approval
    takeLatest(UPDATE_SUB_TASK_APPROVAL, handleSubTaskApproval),
    // Export office subtask report
    takeLatest(EXPORT_OFFICE_SUBTASK_REPORT, handleExportOfficeSubtaskReport),
    // Export all subtask public zone report
    takeLatest(EXPORT_ALL_SUBTASK_PUBLIC_ZONE_REPORT, handleExportAllSubtaskPublicZoneReport),
  ]);
}
